import React from 'react'
import PropTypes from 'prop-types'
import Notification from './Notification'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as notificationActionCreators from '../redux/notifications'

class NotificationList extends React.Component {
  static propTypes = {
    notifications: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number.isRequired,
        color: PropTypes.string.isRequired,
        text: PropTypes.string.isRequired,
      }).isRequired,
    ).isRequired,
  }

  render = () => {
    return (
      <div className="notification-list">
        <div className="container">
          {this.props.notifications.map(n => {
            return (
              <Notification
                autoDismissTimeout={15000}
                dismissible
                key={n.id}
                shadow
                {...n}
                onDismiss={() => this.props.removeNotification(n)}
              />
            )
          })}
        </div>
        <style jsx>
          {`
            .notification-list {
              position: sticky;
              top: 2rem;
              z-index: 1050;
            }
            .container {
              position: absolute;
            }
          `}
        </style>
      </div>
    )
  }
}

const mapStateToProps = ({ notifications }) => ({
  notifications,
})

const mapDispatchToProps = dispatch => {
  return bindActionCreators({ ...notificationActionCreators }, dispatch)
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(NotificationList)



// WEBPACK FOOTER //
// ./src/components/NotificationList.js